import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import styles from "./Auth.module.scss";
import { auth } from "../../services/firebaseConfig";
import { Link } from "react-router-dom";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/`;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await signInWithEmailAndPassword(auth, email, password);
      if (response?.user?.stsTokenManager?.accessToken) {
        setCookie("token", JSON.stringify(response?.user?.stsTokenManager));
        // Redirect completely via normal browser means on login is actually
        // the easiest way to reset the tree state without a complicated context action.
        // To avoid Render 404s, we must ensure the host is configured for SPAs.
        // However, `window.location.href = "/"` does NOT 404 on Render *if* it resolves to the root html.
        // We'll use location.assign.
        window.location.assign("/");
      }
    } catch (err) {
      setError(err?.message ? err?.message : "");
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.leftSection}>
        {/* TODO: Add Logo */}
        <img
          src="https://res.cloudinary.com/daojypjrh/image/upload/logo.jpg"
          alt="JainGlory Foundation"
        />
      </div>

      <div className={styles.rightSection}>
        <div className={styles.formBox}>
          <div className={styles.formHeader}>
            <img
              src="https://res.cloudinary.com/daojypjrh/image/upload/logo.jpg"
              alt="JainGlory Foundation"
              className={styles.mobileLogo}
            />
            <h1>JainGlory Foundation Admin</h1>
            <h2>Login</h2>
            {error ? <span className={styles.error}>{error}</span> : null}
          </div>

          <div className={styles.formBody}>
            <form onSubmit={handleLogin}>
              <TextField
                fullWidth
                className={styles.inputField}
                type="email"
                placeholder="Email"
                variant="outlined"
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <TextField
                fullWidth
                className={styles.inputField}
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                variant="outlined"
                size="small"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                InputProps={{
                  style: { paddingRight: "0px" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        style={{ padding: "10px", margin: "0px" }}
                      >
                        {showPassword ? (
                          <VisibilityOff fontSize="28px" />
                        ) : (
                          <Visibility fontSize="28px" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Link to="/forgot-password" className={styles.forgotPassword}>
                Forgot Password?
              </Link>

              <button type="submit" disabled={loading}>
                {loading ? "Please Wait" : "Login"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
